import { useTheme } from "@emotion/react";
import React from "react";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import newsletterBlackSource from "./newsletter-black.png";
import newsletterWhiteSource from "./newsletter-white.png";
import { StyledImage } from "./styles";

export type Props = React.DetailsHTMLAttributes<HTMLDivElement>;

export const NewsletterIcon: React.FunctionComponent<Props> = ({ ...props }) => {
  const theme = useTheme() as unknown as ThemeType;

  return (
    <StyledImage
      {...props}
      src={
        theme?.newsletterIcon?.icon === "black"
          ? newsletterBlackSource.src
          : newsletterWhiteSource.src
      }
    />
  );
};

NewsletterIcon.displayName = "NewsletterIcon";
